import { useWorkspaceStore } from "@/store/workspace-store";

/**
 * Whether the signed-in user owns the active workspace.
 *
 * This is the same predicate `ensureOpportunityManagerOwnership` applies on the
 * backend — a "company manager" affiliation on the workspace's
 * affiliated_company — so every feature that middleware gates (managing
 * lookbooks, enabling the Raiseboard) can be hidden from members up front
 * instead of 403-ing after they click.
 *
 * Reading is a separate question: GET /lookbooks takes ensureOppOwnership (any
 * affiliation), so this predicate gates the lookbook *controls*, not the list.
 *
 * `affiliation_type` rather than `role`: fetch_opportunities computes role as
 * `aff.role || aff.type`, so an owner who also carries a free-text opportunity
 * role ("Partner") reads as a plain member there. `role` is kept as a fallback
 * for a session whose cached workspace list predates the field.
 */
export function useWorkspaceRole() {
  const activeWorkspace = useWorkspaceStore((s) => s.activeWorkspace);

  const isWorkspaceOwner =
    activeWorkspace?.affiliation_type === "company manager" ||
    activeWorkspace?.role === "company manager";

  return { isWorkspaceOwner };
}
